import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, Fragment as _Fragment, unref as _unref, createVNode as _createVNode, renderList as _renderList, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-xl modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { class: "modal-title" }
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "container-fluid"
}
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-sm-6" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = { class: "error" }
const _hoisted_14 = { class: "col-sm-6" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { class: "error" }
const _hoisted_17 = { class: "col-sm-12" }
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = { class: "error" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-sm-4" }
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = {
  key: 0,
  class: "col-sm-4"
}
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = {
  key: 0,
  class: "col-sm-4"
}
const _hoisted_28 = { class: "form-group" }
const _hoisted_29 = {
  key: 1,
  class: "col-sm-4"
}
const _hoisted_30 = { class: "form-group" }
const _hoisted_31 = { class: "checkbox" }
const _hoisted_32 = {
  key: 0,
  class: "row"
}
const _hoisted_33 = { class: "col-sm-4" }
const _hoisted_34 = { class: "col-sm-4" }
const _hoisted_35 = {
  key: 1,
  class: "row"
}
const _hoisted_36 = { class: "col-sm-4" }
const _hoisted_37 = { class: "col-sm-4" }
const _hoisted_38 = { class: "col-sm-4" }
const _hoisted_39 = {
  key: 2,
  class: "row"
}
const _hoisted_40 = { class: "col-sm-4" }
const _hoisted_41 = { class: "col-sm-4" }
const _hoisted_42 = {
  key: 3,
  class: "row"
}
const _hoisted_43 = { class: "col-sm-4" }
const _hoisted_44 = { class: "col-sm-4" }
const _hoisted_45 = { class: "mt-3" }
const _hoisted_46 = {
  key: 0,
  class: "dropdown d-inline"
}
const _hoisted_47 = {
  class: "dropdown-menu",
  style: {"max-height":"300px","overflow-y":"auto"}
}
const _hoisted_48 = ["onClick"]
const _hoisted_49 = { class: "row mt-3" }
const _hoisted_50 = { class: "col-sm-4" }
const _hoisted_51 = {
  class: "row",
  style: {"margin-top":"5px"}
}
const _hoisted_52 = { class: "col-sm-3" }
const _hoisted_53 = ["onUpdate:modelValue"]
const _hoisted_54 = { class: "col-sm-4" }
const _hoisted_55 = { key: 0 }
const _hoisted_56 = ["onUpdate:modelValue"]
const _hoisted_57 = { key: 1 }
const _hoisted_58 = ["onUpdate:modelValue"]
const _hoisted_59 = { key: 2 }
const _hoisted_60 = { key: 3 }
const _hoisted_61 = ["onUpdate:modelValue"]
const _hoisted_62 = { class: "col-sm-4" }
const _hoisted_63 = ["onUpdate:modelValue"]
const _hoisted_64 = { class: "col-sm-1" }
const _hoisted_65 = ["onClick"]
const _hoisted_66 = { class: "error" }
const _hoisted_67 = { class: "d-flex justify-content-end" }
const _hoisted_68 = { class: "dropdown" }
const _hoisted_69 = {
  class: "dropdown-menu dropdown-menu-right",
  style: {"overflow-y":"auto","max-height":"400px"}
}
const _hoisted_70 = ["onClick"]
const _hoisted_71 = { class: "form-group" }
const _hoisted_72 = { class: "error" }
const _hoisted_73 = { key: 0 }
const _hoisted_74 = { class: "shadow-none p-3 mb-3 bg-light rounded" }
const _hoisted_75 = { class: "form-inline" }
const _hoisted_76 = ["onUpdate:modelValue"]
const _hoisted_77 = { class: "row" }
const _hoisted_78 = { class: "col-sm-6" }
const _hoisted_79 = { style: {"margin":"0"} }
const _hoisted_80 = { class: "modal-footer" }
const _hoisted_81 = ["disabled"]

import { computed, ref, watch, type Ref } from 'vue'
    import { DatePicker, type DatePickerChangeEvent } from '@progress/kendo-vue-dateinputs'

    import { insertIntoTextArea1, localToUtcDate } from "@common/Common"
    import { ValidationError } from '@common/types'

    import
        {
            AttributeEditorDialogViewModel,
            SaveDateAttributeEventPayload,
            SaveEmailAttributeEventPayload,
            SaveMultilineAttributeEventPayload,
            SaveNumericAttributeEventPayload,
            SaveTextAttributeEventPayload,
            TestScriptEventPayload
        } from '@Quest/CorporateAttributes/Components/AttributeEditorDialog'

    import type { AttributeDefinedValueReadModel } from '@Alternatives/Attributes/Domain/readmodels'
    import { RealDefinedValue } from '@Alternatives/Model'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AttributeEditorDialog',
  props: {
    viewModel: {}
  },
  emits: ["test-script", "save-numeric", "save-date", "save-text", "save-email", "save-multiline"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    const vm = props.viewModel

    const opened = computed(() => vm?.opened ?? false)
    const initialized = computed(() => vm.initialized)

    const dialogTitle = computed(() => vm.dialogTitle)
    const confirmButtonLabel = computed(() => vm.confirmButtonLabel)
    const allowChangeAttributeType = computed(() => vm.allowChangeAttributeType)
    const allowMultipleValuesEnabled = computed(() => vm.allowMultipleValuesEnabled)
    const allowInputTypeEvaluate = computed(() => vm.allowInputTypeEvaluate)

    const scriptTestInputs = computed(() => vm.scriptTestInputs)
    const scales = computed(() => vm.scales)
    const numericAttributeNames = computed(() => vm.numericAttributeNames)

    const nameError = computed(() => vm.errors.find(e => e.Context === "Name")?.Error ?? null)
    const descriptionError = computed(() => vm.errors.find(e => e.Context === "Description")?.Error ?? null)
    const sectionError = computed(() => vm.errors.find(e => e.Context === "Section")?.Error ?? null)
    const scriptError = computed(() => vm.errors.find(e => e.Context === "Script")?.Error ?? null)
    const definedValuesErrors = computed(() => vm.errors.filter(e => e.Context === "DefinedValues").map(e => e.Error))

    const id = computed(() => vm.attributeId)

    const name = computed({
        get: () => vm.name,
        set: v => vm.name = v
    })

    const section = computed({
        get: () => vm.section,
        set: v => vm.section = v
    })

    const description = computed({
        get: () => vm.description,
        set: v => vm.description = v
    })

    const script = computed({
        get: () => vm.script,
        set: v => vm.script = v
    })

    const attributeType = computed({
        get: () => vm.attributeType,
        set: v => vm.attributeType = v
    })

    const inputType = computed({
        get: () => vm.inputType,
        set: v => vm.inputType = v
    })

    const isMultivalue = computed({
        get: () => vm.isMultivalue,
        set: v => vm.isMultivalue = v
    })

    const minLength = computed({
        get: () => vm.minLength,
        set: v => vm.minLength = v
    })

    const maxLength = computed({
        get: () => vm.maxLength,
        set: v => vm.maxLength = v
    })

    const minValue = computed({
        get: () => vm.minValue,
        set: v => vm.minValue = v
    })

    const maxValue = computed({
        get: () => vm.maxValue,
        set: v => vm.maxValue = v
    })

    const minDate = computed({
        get: () => vm.minDate,
        set: v => vm.minDate = v
    })

    const maxDate = computed({
        get: () => vm.maxDate,
        set: v => vm.maxDate = v
    })

    const rows = computed({
        get: () => vm.rows,
        set: v => vm.rows = v
    })

    const definedValues = computed({
        get: () => vm.definedValues,
        set: v => vm.definedValues = v
    })

    const scriptTestResult = computed({
        get: () => vm.scriptTestResult,
        set: v => vm.scriptTestResult = v
    })

    const testScriptPanelVisible = ref(false)
    const ta = ref<HTMLTextAreaElement | null>(null)


    watch(testScriptPanelVisible, (val) =>
    {
        if (val === true)
        {
            const re = /\[([^\]]*)\]/g
            const matches: Set<string> = new Set()

            let match
            while ((match = re.exec(script.value ?? "")) !== null)
            {
                matches.add(match[1])
            }

            const newValues = Array.from(matches).map(a =>
            {
                const vals = scriptTestInputs.value.filter(b => b.Name === a)
                return { Name: a, Value: vals.length > 0 ? vals[0].Value : 0 }
            })

            vm.scriptTestInputs = newValues
        }
    })

    function addDefinedValue()
    {
        definedValues.value.push({ Name: "", Value: null, Description: null })
    }

    function removeDefinedValue(dv: AttributeDefinedValueReadModel)
    {
        definedValues.value = definedValues.value.filter(x => x !== dv)
    }

    function insertAttributeIntoScript(attrName: string)
    {
        if (!ta.value) return
        insertIntoTextArea1(ta.value, `[${attrName}]`)
        ta.value.dispatchEvent(new Event('input'))
    }

    function onMinDateChanged(event: DatePickerChangeEvent)
    {
        const localDate = event.target.value as Date
        minDate.value = localToUtcDate(localDate)
    }

    function onMaxDateChanged(event: DatePickerChangeEvent)
    {
        const localDate = event.target.value as Date
        maxDate.value = localToUtcDate(localDate)
    }

    function onDefinedLevelDateChanged(event: DatePickerChangeEvent, dv: AttributeDefinedValueReadModel)
    {
        const localDate = event.target.value as Date
        dv.Value = localToUtcDate(localDate)
    }

    function handleLoadScriptTestResult()
    {
        scriptTestResult.value = null
        emit('test-script', new TestScriptEventPayload(script.value, scriptTestInputs.value))
    }

    function handleFormSubmit()
    {
        vm.clearValidationErrors()

        const filteredDefinedValues =
            definedValues.value.filter(a => a.Name || a.Value || a.Description)

        switch (attributeType.value)
        {
            case "Real":
                emit('save-numeric',
                    new SaveNumericAttributeEventPayload(id.value, name.value, description.value, section.value, inputType.value,
                        isMultivalue.value, minValue.value, maxValue.value, script.value, filteredDefinedValues as RealDefinedValue[]))
                break

            case "Date":
                emit('save-date',
                    new SaveDateAttributeEventPayload(id.value, name.value, description.value, section.value, inputType.value, isMultivalue.value, minDate.value, maxDate.value, filteredDefinedValues))
                break

            case "Text":
                emit('save-text',
                    new SaveTextAttributeEventPayload(id.value, name.value, description.value, section.value, inputType.value, isMultivalue.value, minLength.value, maxLength.value, filteredDefinedValues))
                break

            case "Email":
                emit('save-email',
                    new SaveEmailAttributeEventPayload(id.value, name.value, description.value, section.value, inputType.value, isMultivalue.value, filteredDefinedValues))
                break

            case "MultilineText":
                emit('save-multiline',
                    new SaveMultilineAttributeEventPayload(id.value, name.value, description.value, section.value, rows.value ?? 3, minLength.value, maxLength.value))
                break

            default:
                console.log(`Unknown attribute type: ${attributeType.value}`)
                break
        }
    }

    function close()
    {
        vm.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h5", _hoisted_6, _toDisplayString(dialogTitle.value), 1 /* TEXT */),
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: close
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_7, [
                (!initialized.value)
                  ? (_openBlock(), _createElementBlock("h2", _hoisted_8, [...(_cache[16] || (_cache[16] = [
                      _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
                      _createTextVNode(" Loading...", -1 /* CACHED */)
                    ]))]))
                  : _createCommentVNode("v-if", true),
                (initialized.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("form", {
                        id: "attribute-editor-dialog-form",
                        onSubmit: _withModifiers(handleFormSubmit, ["prevent"])
                      }, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _cache[17] || (_cache[17] = _createElementVNode("label", null, [
                                _createElementVNode("span", { class: "text-danger" }, "*"),
                                _createTextVNode(" Name")
                              ], -1 /* CACHED */)),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
                                type: "text",
                                class: "form-control",
                                required: "",
                                minlength: "2",
                                maxlength: "100"
                              }, null, 512 /* NEED_PATCH */), [
                                [
                                  _vModelText,
                                  name.value,
                                  void 0,
                                  { trim: true }
                                ]
                              ]),
                              _cache[18] || (_cache[18] = _createElementVNode("small", null, "Name of the attribute", -1 /* CACHED */)),
                              _createElementVNode("div", _hoisted_13, _toDisplayString(nameError.value), 1 /* TEXT */)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, [
                              _cache[19] || (_cache[19] = _createElementVNode("label", null, "Section", -1 /* CACHED */)),
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((section).value = $event)),
                                class: "form-control",
                                maxlength: "100"
                              }, null, 512 /* NEED_PATCH */), [
                                [
                                  _vModelText,
                                  section.value,
                                  void 0,
                                  { trim: true }
                                ]
                              ]),
                              _cache[20] || (_cache[20] = _createElementVNode("small", null, "Name of the section. Use sections to group attributes e.g. financials.", -1 /* CACHED */)),
                              _createElementVNode("div", _hoisted_16, _toDisplayString(sectionError.value), 1 /* TEXT */)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                              _cache[21] || (_cache[21] = _createElementVNode("label", null, "Description", -1 /* CACHED */)),
                              _withDirectives(_createElementVNode("textarea", {
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((description).value = $event)),
                                type: "text",
                                class: "form-control",
                                rows: "3",
                                maxlength: "500"
                              }, null, 512 /* NEED_PATCH */), [
                                [
                                  _vModelText,
                                  description.value,
                                  void 0,
                                  { trim: true }
                                ]
                              ]),
                              _cache[22] || (_cache[22] = _createElementVNode("small", null, "Description of the attribute.", -1 /* CACHED */)),
                              _createElementVNode("div", _hoisted_19, _toDisplayString(descriptionError.value), 1 /* TEXT */)
                            ])
                          ])
                        ]),
                        _cache[49] || (_cache[49] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                              _cache[24] || (_cache[24] = _createElementVNode("label", null, "Type", -1 /* CACHED */)),
                              _withDirectives(_createElementVNode("select", {
                                class: "form-control",
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((attributeType).value = $event)),
                                disabled: !allowChangeAttributeType.value,
                                required: ""
                              }, [...(_cache[23] || (_cache[23] = [
                                _createStaticVNode("<option value=\"Real\">Numeric</option><option value=\"Text\">Text</option><option value=\"MultilineText\">Multiline text</option><option value=\"Date\">Date</option><option value=\"Email\">Email</option>", 5)
                              ]))], 8 /* PROPS */, _hoisted_23), [
                                [_vModelSelect, attributeType.value]
                              ])
                            ])
                          ]),
                          (attributeType.value === 'Real')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                _createElementVNode("div", _hoisted_25, [
                                  _cache[27] || (_cache[27] = _createElementVNode("label", null, "Input type", -1 /* CACHED */)),
                                  _withDirectives(_createElementVNode("select", {
                                    class: "form-control",
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((inputType).value = $event)),
                                    required: ""
                                  }, [
                                    _cache[25] || (_cache[25] = _createElementVNode("option", { value: "Manual" }, "Enter value manually", -1 /* CACHED */)),
                                    _cache[26] || (_cache[26] = _createElementVNode("option", { value: "List" }, "Pick value from list", -1 /* CACHED */)),
                                    _createElementVNode("option", {
                                      value: "Evaluate",
                                      disabled: allowInputTypeEvaluate.value === false
                                    }, " Based on formula ", 8 /* PROPS */, _hoisted_26)
                                  ], 512 /* NEED_PATCH */), [
                                    [_vModelSelect, inputType.value]
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("v-if", true),
                          (attributeType.value !== 'MultilineText')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                (attributeType.value !== 'Real')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                      _createElementVNode("div", _hoisted_28, [
                                        _cache[29] || (_cache[29] = _createElementVNode("label", null, "Input type", -1 /* CACHED */)),
                                        _withDirectives(_createElementVNode("select", {
                                          class: "form-control",
                                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((inputType).value = $event))
                                        }, [...(_cache[28] || (_cache[28] = [
                                          _createElementVNode("option", { value: "Manual" }, "Enter value manually", -1 /* CACHED */),
                                          _createElementVNode("option", { value: "List" }, "Pick value from list", -1 /* CACHED */)
                                        ]))], 512 /* NEED_PATCH */), [
                                          [_vModelSelect, inputType.value]
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("v-if", true),
                                (allowMultipleValuesEnabled.value === true && inputType.value !== 'Evaluate')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                      _createElementVNode("div", _hoisted_30, [
                                        _cache[31] || (_cache[31] = _createElementVNode("label", null, "Multi-select", -1 /* CACHED */)),
                                        _createElementVNode("div", _hoisted_31, [
                                          _createElementVNode("label", null, [
                                            _withDirectives(_createElementVNode("input", {
                                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((isMultivalue).value = $event)),
                                              type: "checkbox"
                                            }, null, 512 /* NEED_PATCH */), [
                                              [_vModelCheckbox, isMultivalue.value]
                                            ]),
                                            _cache[30] || (_cache[30] = _createTextVNode(" Allow multiple values ", -1 /* CACHED */))
                                          ])
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("v-if", true)
                              ], 64 /* STABLE_FRAGMENT */))
                            : _createCommentVNode("v-if", true)
                        ]),
                        _cache[50] || (_cache[50] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                        (inputType.value === 'Manual')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (attributeType.value === 'Text')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                    _createElementVNode("div", _hoisted_33, [
                                      _cache[32] || (_cache[32] = _createElementVNode("label", null, "Min length", -1 /* CACHED */)),
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((minLength).value = $event)),
                                        type: "number",
                                        class: "form-control",
                                        min: "0",
                                        step: "1"
                                      }, null, 512 /* NEED_PATCH */), [
                                        [
                                          _vModelText,
                                          minLength.value,
                                          void 0,
                                          { number: true }
                                        ]
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_34, [
                                      _cache[33] || (_cache[33] = _createElementVNode("label", null, "Max length", -1 /* CACHED */)),
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((maxLength).value = $event)),
                                        type: "number",
                                        class: "form-control",
                                        min: "1",
                                        step: "1"
                                      }, null, 512 /* NEED_PATCH */), [
                                        [
                                          _vModelText,
                                          maxLength.value,
                                          void 0,
                                          { number: true }
                                        ]
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("v-if", true),
                              (attributeType.value === 'MultilineText')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                    _createElementVNode("div", _hoisted_36, [
                                      _cache[34] || (_cache[34] = _createElementVNode("label", null, "Min length", -1 /* CACHED */)),
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((minLength).value = $event)),
                                        type: "number",
                                        class: "form-control",
                                        min: "0",
                                        step: "1"
                                      }, null, 512 /* NEED_PATCH */), [
                                        [
                                          _vModelText,
                                          minLength.value,
                                          void 0,
                                          { number: true }
                                        ]
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_37, [
                                      _cache[35] || (_cache[35] = _createElementVNode("label", null, "Max length", -1 /* CACHED */)),
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((maxLength).value = $event)),
                                        type: "number",
                                        class: "form-control",
                                        min: "1",
                                        step: "1"
                                      }, null, 512 /* NEED_PATCH */), [
                                        [
                                          _vModelText,
                                          maxLength.value,
                                          void 0,
                                          { number: true }
                                        ]
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_38, [
                                      _cache[36] || (_cache[36] = _createElementVNode("label", null, "Number of lines", -1 /* CACHED */)),
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((rows).value = $event)),
                                        type: "number",
                                        class: "form-control",
                                        min: "0",
                                        step: "1"
                                      }, null, 512 /* NEED_PATCH */), [
                                        [
                                          _vModelText,
                                          rows.value,
                                          void 0,
                                          { number: true }
                                        ]
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("v-if", true),
                              (attributeType.value === 'Real')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                    _createElementVNode("div", _hoisted_40, [
                                      _cache[37] || (_cache[37] = _createElementVNode("label", null, "Min value", -1 /* CACHED */)),
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((minValue).value = $event)),
                                        type: "number",
                                        class: "form-control"
                                      }, null, 512 /* NEED_PATCH */), [
                                        [
                                          _vModelText,
                                          minValue.value,
                                          void 0,
                                          { number: true }
                                        ]
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_41, [
                                      _cache[38] || (_cache[38] = _createElementVNode("label", null, "Max value", -1 /* CACHED */)),
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((maxValue).value = $event)),
                                        type: "number",
                                        class: "form-control"
                                      }, null, 512 /* NEED_PATCH */), [
                                        [
                                          _vModelText,
                                          maxValue.value,
                                          void 0,
                                          { number: true }
                                        ]
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("v-if", true),
                              (attributeType.value === 'Date')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                    _createElementVNode("div", _hoisted_43, [
                                      _cache[39] || (_cache[39] = _createElementVNode("label", null, "Min value", -1 /* CACHED */)),
                                      _createVNode(_unref(DatePicker), {
                                        value: minDate.value,
                                        onChange: onMinDateChanged
                                      }, null, 8 /* PROPS */, ["value"])
                                    ]),
                                    _createElementVNode("div", _hoisted_44, [
                                      _cache[40] || (_cache[40] = _createElementVNode("label", null, "Max value", -1 /* CACHED */)),
                                      _createVNode(_unref(DatePicker), {
                                        value: maxDate.value,
                                        onChange: onMaxDateChanged
                                      }, null, 8 /* PROPS */, ["value"])
                                    ])
                                  ]))
                                : _createCommentVNode("v-if", true)
                            ], 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("v-if", true),
                        (inputType.value === 'List')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createElementVNode("div", _hoisted_45, [
                                _createElementVNode("button", {
                                  class: "btn btn-sm btn-outline-secondary mr-1",
                                  onClick: addDefinedValue
                                }, "Add value"),
                                (attributeType.value === 'Real')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                      _cache[41] || (_cache[41] = _createElementVNode("button", {
                                        class: "btn btn-sm btn-outline-secondary dropdown-toggle",
                                        "data-toggle": "dropdown"
                                      }, " Scales templates ", -1 /* CACHED */)),
                                      _createElementVNode("div", _hoisted_47, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scales.value, (s) => {
                                          return (_openBlock(), _createElementBlock("a", {
                                            key: s.Id,
                                            class: "dropdown-item",
                                            onClick: ($event: any) => (definedValues.value = s.Levels)
                                          }, _toDisplayString(s.Name), 9 /* TEXT, PROPS */, _hoisted_48))
                                        }), 128 /* KEYED_FRAGMENT */))
                                      ])
                                    ]))
                                  : _createCommentVNode("v-if", true)
                              ]),
                              _createElementVNode("div", _hoisted_49, [
                                _cache[42] || (_cache[42] = _createElementVNode("div", { class: "col-sm-3" }, [
                                  _createElementVNode("label", null, "Name")
                                ], -1 /* CACHED */)),
                                _createElementVNode("div", _hoisted_50, [
                                  _createElementVNode("label", null, _toDisplayString(attributeType.value !== 'Email' ? 'Value' : 'Email'), 1 /* TEXT */)
                                ]),
                                _cache[43] || (_cache[43] = _createElementVNode("div", { class: "col-sm-4" }, [
                                  _createElementVNode("label", null, "Description")
                                ], -1 /* CACHED */))
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(definedValues.value, (dv) => {
                                return (_openBlock(), _createElementBlock("div", null, [
                                  _createElementVNode("div", _hoisted_51, [
                                    _createElementVNode("div", _hoisted_52, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        "onUpdate:modelValue": ($event: any) => ((dv.Name) = $event),
                                        class: "form-control",
                                        required: "",
                                        minlength: "2",
                                        maxlength: "100"
                                      }, null, 8 /* PROPS */, _hoisted_53), [
                                        [
                                          _vModelText,
                                          dv.Name,
                                          void 0,
                                          { trim: true }
                                        ]
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_54, [
                                      (attributeType.value === 'Text')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "text",
                                              "onUpdate:modelValue": ($event: any) => ((dv.Value) = $event),
                                              required: "",
                                              class: "form-control"
                                            }, null, 8 /* PROPS */, _hoisted_56), [
                                              [
                                                _vModelText,
                                                dv.Value,
                                                void 0,
                                                { trim: true }
                                              ]
                                            ])
                                          ]))
                                        : _createCommentVNode("v-if", true),
                                      (attributeType.value === 'Real')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "number",
                                              "onUpdate:modelValue": ($event: any) => ((dv.Value) = $event),
                                              required: "",
                                              class: "form-control"
                                            }, null, 8 /* PROPS */, _hoisted_58), [
                                              [
                                                _vModelText,
                                                dv.Value,
                                                void 0,
                                                { number: true }
                                              ]
                                            ])
                                          ]))
                                        : _createCommentVNode("v-if", true),
                                      (attributeType.value === 'Date')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                            _createVNode(_unref(DatePicker), {
                                              value: dv.Value != null ? new Date(dv.Value) : null,
                                              onChange: ($event: any) => (onDefinedLevelDateChanged($event, dv))
                                            }, null, 8 /* PROPS */, ["value", "onChange"])
                                          ]))
                                        : _createCommentVNode("v-if", true),
                                      (attributeType.value === 'Email')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "email",
                                              "onUpdate:modelValue": ($event: any) => ((dv.Value) = $event),
                                              required: "",
                                              class: "form-control"
                                            }, null, 8 /* PROPS */, _hoisted_61), [
                                              [
                                                _vModelText,
                                                dv.Value,
                                                void 0,
                                                { trim: true }
                                              ]
                                            ])
                                          ]))
                                        : _createCommentVNode("v-if", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_62, [
                                      _withDirectives(_createElementVNode("textarea", {
                                        type: "text",
                                        "onUpdate:modelValue": ($event: any) => ((dv.Description) = $event),
                                        class: "form-control",
                                        rows: "2"
                                      }, null, 8 /* PROPS */, _hoisted_63), [
                                        [
                                          _vModelText,
                                          dv.Description,
                                          void 0,
                                          { trim: true }
                                        ]
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_64, [
                                      _createElementVNode("button", {
                                        type: "button",
                                        onClick: ($event: any) => (removeDefinedValue(dv)),
                                        class: "btn btn-outline-secondary"
                                      }, [...(_cache[44] || (_cache[44] = [
                                        _createElementVNode("i", { class: "fa fa-times-circle" }, null, -1 /* CACHED */)
                                      ]))], 8 /* PROPS */, _hoisted_65)
                                    ])
                                  ])
                                ]))
                              }), 256 /* UNKEYED_FRAGMENT */)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(definedValuesErrors.value, (e) => {
                                return (_openBlock(), _createElementBlock("div", null, [
                                  _createElementVNode("div", _hoisted_66, _toDisplayString(e), 1 /* TEXT */)
                                ]))
                              }), 256 /* UNKEYED_FRAGMENT */))
                            ], 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("v-if", true),
                        (inputType.value === 'Evaluate')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _cache[47] || (_cache[47] = _createElementVNode("label", null, "Formula", -1 /* CACHED */)),
                              _createElementVNode("div", _hoisted_67, [
                                _createElementVNode("div", _hoisted_68, [
                                  _cache[45] || (_cache[45] = _createElementVNode("button", {
                                    class: "btn btn-sm btn-secondary dropdown-toggle",
                                    "data-toggle": "dropdown"
                                  }, "Insert", -1 /* CACHED */)),
                                  _createElementVNode("div", _hoisted_69, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numericAttributeNames.value, (attrName) => {
                                      return (_openBlock(), _createElementBlock("a", {
                                        key: attrName,
                                        class: "dropdown-item",
                                        onClick: ($event: any) => (insertAttributeIntoScript(attrName))
                                      }, _toDisplayString(attrName), 9 /* TEXT, PROPS */, _hoisted_70))
                                    }), 128 /* KEYED_FRAGMENT */))
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_71, [
                                _withDirectives(_createElementVNode("textarea", {
                                  ref_key: "ta",
                                  ref: ta,
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((script).value = $event)),
                                  rows: "5",
                                  class: "form-control"
                                }, null, 512 /* NEED_PATCH */), [
                                  [_vModelText, script.value]
                                ]),
                                _createElementVNode("div", _hoisted_72, _toDisplayString(scriptError.value), 1 /* TEXT */)
                              ]),
                              _createElementVNode("a", {
                                class: "text-primary",
                                onClick: _cache[15] || (_cache[15] = ($event: any) => (testScriptPanelVisible.value = !testScriptPanelVisible.value))
                              }, "Test formula"),
                              _cache[48] || (_cache[48] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                              (testScriptPanelVisible.value === true)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                                    _createElementVNode("div", _hoisted_74, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scriptTestInputs.value, (i) => {
                                        return (_openBlock(), _createElementBlock("div", _hoisted_75, [
                                          _createElementVNode("label", null, _toDisplayString(i.Name) + ": ", 1 /* TEXT */),
                                          _withDirectives(_createElementVNode("input", {
                                            type: "number",
                                            "onUpdate:modelValue": ($event: any) => ((i.Value) = $event),
                                            class: "form-control",
                                            style: {"width":"90px"}
                                          }, null, 8 /* PROPS */, _hoisted_76), [
                                            [
                                              _vModelText,
                                              i.Value,
                                              void 0,
                                              { number: true }
                                            ]
                                          ])
                                        ]))
                                      }), 256 /* UNKEYED_FRAGMENT */)),
                                      _cache[46] || (_cache[46] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                                      _createElementVNode("div", _hoisted_77, [
                                        _createElementVNode("div", { class: "col-sm-6" }, [
                                          _createElementVNode("button", {
                                            type: "button",
                                            onClick: handleLoadScriptTestResult,
                                            class: "btn btn-outline-secondary"
                                          }, "Test")
                                        ]),
                                        _createElementVNode("div", _hoisted_78, [
                                          _createElementVNode("h3", _hoisted_79, " Result: " + _toDisplayString(scriptTestResult.value), 1 /* TEXT */)
                                        ])
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("v-if", true)
                            ], 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("v-if", true)
                      ], 32 /* NEED_HYDRATION */)
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_80, [
                _createElementVNode("button", {
                  type: "submit",
                  form: "attribute-editor-dialog-form",
                  disabled: !initialized.value,
                  class: "btn btn-primary"
                }, _toDisplayString(confirmButtonLabel.value), 9 /* TEXT, PROPS */, _hoisted_81),
                _createElementVNode("button", {
                  type: "button",
                  onClick: close,
                  class: "btn btn-outline-secondary"
                }, "Close")
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})